<template>
  <base-dialog
    :title="'Owner verification details'"
    :action="onAction"
    :action-name="'Update'"
    :close="onClose"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row
        justify="center"
        align="center"
      >
        <!--        <v-alert-->
        <!--          type="info"-->
        <!--          outlined-->
        <!--          border="left"-->
        <!--        >-->
        <!--          Once your information is verified, it cannot be adjusted without contacting support.-->
        <!--        </v-alert>-->
        <v-col cols="10">
          <div class="title mb-3">Person Details</div>
          <v-text-field
            outlined
            dense
            v-model="model.first_name"
            label="First Name"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.last_name"
            label="Last Name"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.email"
            label="Email"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.phone"
            label="Phone"
            type="text"
          />
          <span
            v-if="model.id_number_provided"
            class="subtitle-1 grey--text"
          >ID number provided</span>
          <v-text-field
            outlined
            dense
            v-if="!model.id_number_provided"
            v-model="model.id_number"
            label="ID Number"
            :disabled="model.id_number_provided"
            hint="Government issued SIN/SSN"
            persistent-hint
            type="text"
          />
          <!--          <v-text-field-->
          <!--            v-model="model.dob"-->
          <!--            label="Phone number"-->
          <!--            type="text"-->
          <!--          ></v-text-field>-->

          <!--          <v-text-field-->
          <!--            v-model="model.company.tax_id"-->
          <!--            label="Tax ID"-->
          <!--            type="text"-->
          <!--            persistent-hint-->
          <!--            hint="This value will never be displayed in the application"-->
          <!--          ></v-text-field>-->

          <v-divider class="my-5"/>

          <div class="title mb-3">Address</div>
          <v-text-field
            outlined
            dense
            v-model="model.address.line1"
            label="Address line 1"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.address.line2"
            label="Address line 2"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.address.city"
            label="City"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.address.state"
            label="Province / State"
            type="text"
          />
          <v-text-field
            outlined
            dense
            v-model="model.address.postal_code"
            label="Postal Code"
            type="text"
          />

          <v-divider class="my-5"/>

          Date of birth:
          <v-row>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="model.dob.day"
                label="Day"
                type="text"
                placeholder="DD"
                hide-details
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="model.dob.month"
                label="Month"
                type="text"
                placeholder="MM"
                hide-details
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                v-model="model.dob.year"
                label="Year"
                type="text"
                placeholder="YYYY"
                hide-details
              />
            </v-col>
          </v-row>


          <v-divider class="my-5"/>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { get, isEmpty } from 'lodash'
import axios from 'axios/index'
import { getPersonToken, getPiiToken } from "../../services/stripe.service"

import BaseDialog from "../Common/BaseDialog"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: {
    BaseDialog,
  },
  props: {
    person: {
      type: Object,
      default: () => ({})
    },
  },
  created() {
    this.initPerson = { ...this.person }
    this.resetModel()
  },
  data() {
    return {
      initPerson: {},
      file: null,
      model: {
        relationship: {
          representative: true
        },
        first_name: undefined,
        last_name: undefined,
        id_number: undefined,
        id_number_provided: false,
        email: undefined,
        phone: undefined,
        address: {
          line1: undefined,
          line2: undefined,
          city: undefined,
          country: undefined,
          postal_code: undefined,
          state: undefined,
        },
        dob: {
          day: undefined,
          month: undefined,
          year: undefined,
        }
      },
    }
  },
  methods: {
    ...mapActions([ 'updateAccountOwnerRequirements', 'createFile', 'afterLogin' ]),
    resetModel() {
      this.model = { ...this.initPerson }
      this.model.relationship = { ...this.initPerson.relation }
      this.model.address = { ...this.initPerson.address }
      this.model.dob = { ...this.initPerson.dob }
    },
    onClose() {
      this.resetModel()
      this.$emit('close')
    },
    onAction() {
      const personPayload = {
        relationship: {
          representative: true
        },
        first_name: get(this.model, 'first_name') || undefined,
        last_name: get(this.model, 'last_name') || undefined,
        id_number: get(this.model, 'id_number') || undefined,
        id_number_provided: get(this.model, 'id_number_provided', false),
        email: get(this.model, 'email') || undefined,
        phone: get(this.model, 'phone') || undefined,
        address: {
          city: get(this.model, 'address.city') || undefined,
          country: get(this.model, 'address.country') || undefined,
          line1: get(this.model, 'address.line1') || undefined,
          line2: get(this.model, 'address.line2') || undefined,
          postal_code: get(this.model, 'address.postal_code') || undefined,
          state: get(this.model, 'address.state') || undefined,
        },
        dob: {
          day: get(this.model, 'dob.day') || undefined,
          month: get(this.model, 'dob.month') || undefined,
          year: get(this.model, 'dob.year') || undefined,
        }
      }

      const { day, month, year } = get(this.model, 'dob', {})
      if (isEmpty(day) && isEmpty(month) && isEmpty(year)) {
        delete personPayload.dob
      }

      const doUpdateAccount = result => {
        const { token, error } = result

        if (error) {
          this.$store.dispatch('snackError', error)

          return { status: 400 }
        } else {
          const personTokenId = token.id
          const payload = { person_token: personTokenId }

          return this.updateAccountOwnerRequirements(payload)
            .then(person => {
              if (!isErrorResponse(person)) {
                this.$store.dispatch('snackBar', { color: 'success', text: 'Ownership updated' })
                // Since the account was updated and its attached to our token for api calls
                // we need to refresh our token.
                const afterLoginPayload = {
                  silentLoading: true
                }
                this.afterLogin(afterLoginPayload)

                this.initPerson = { ...person }
                this.resetModel()
                this.$emit('action', person)
              }

              return person
            })
        }
      }

      return getPersonToken(personPayload)
        .then(doUpdateAccount)
    }
  }
}
</script>

